// extracted by mini-css-extract-plugin
export default {"postTitleContainer":"ESoZC5","titleWrapper":"Cn7T20","title":"ZSHRp1","titleLink":"eEF09j","updateDate":"z19QG5","topWrapper":"IPdnfn"};